import { Injectable } from '@angular/core';
import { RequestOptions, Response } from '@angular/http';

import { AuthHttp } from '../../../../../common/index';
import { AppSettings } from '../../../../../settings/index';

@Injectable()
export class DriverService {
    constructor(private http: AuthHttp) { }

    getDriverNamesWithVehicleNo() {
        return this.http.get(AppSettings.apiEndpoint + 'Driver/GetDriverNamesWithVehicleNo')
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/outbound/order/driver.service.ts